// import { WEBSERVER } from './Webserver.js';
// import { PORT } from './Port.js';
import { API } from './API.js';

import axios from 'axios';

// const url = WEBSERVER + ':' + PORT + '/api/tastings/'

const url = API + '/tastings/'
const debug = false;

class Tastings {
    // get tastings
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(tasting=> ({
                        ...tasting,
                        name: tasting.name
                    }))
                );
                if (debug) console.log("data = ", data)
            } catch(err) {
                reject(err);
            }
        })
    }

    // get one tasting
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('Tasting.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                if (debug) console.log('Tastings.getone: ',error)
            })
    }

    // create tasting
    static create(postdata) {
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Tastings.create: ',response)
                return response.data._id
            })
            .catch(error => {
                if (debug) console.log('Tastings.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Tastings.update: id=',id)
        if (debug) console.log('Tastings.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Tastings.update: ',response)
            })
            .catch(error => {
                if (debug) console.log('Tastings.update: ',error)
            })
    }

    // delete tasting
    static delete(id) {
        return axios.delete(`${url}${id}`)
    }
}

export default Tastings